/** fileName: IModalBody.js
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React, {Children, useEffect, useRef} from 'react';
import SwipeableViews from "react-swipeable-views";
import useId from "@mui/material/utils/useId";

const IModalBody = ({index, children}) => {
    const arrayChildren = Children.toArray(children);
    const sRef = useRef();
    const id = useId();

    useEffect(() => {
        setInterval(() => {
            if (!sRef) return false;
            sRef?.current?.updateHeight();
        }, 200)
    }, [])

    return (

        <SwipeableViews ref={sRef} disabled={true} animateHeight={true} style={{width:'100%'}}
                        axis={'x-reverse'} index={index}>
            {arrayChildren?.map((child, index) => {
                return (
                    <div key={`modal_page_${id}_${index}`} style={{padding: '32px 0px'}}>
                        {child}
                    </div>
                )
            })}
        </SwipeableViews>

    );
};

export default IModalBody;